interface ReviewFiltersProps {
  sortBy: "recent" | "highest" | "lowest";
  setSortBy: (value: "recent" | "highest" | "lowest") => void;
  filterContacted: boolean;
  setFilterContacted: (value: boolean) => void;
}

const ReviewFilters = ({ sortBy, setSortBy, filterContacted, setFilterContacted }: ReviewFiltersProps) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        onClick={() => setFilterContacted(!filterContacted)}
        className={`rounded-md border px-3 py-1.5 text-xs font-medium transition-colors ${
          filterContacted
            ? "border-brand-ink bg-brand-ink text-white"
            : "border-brand-cloud bg-white text-brand-slate hover:bg-brand-mist hover:text-brand-ink"
        }`}
      >
        {filterContacted ? "Show All" : "Only Contacted"}
      </button>
      <select
        className="h-8 rounded-md border border-brand-cloud bg-white px-3 py-1.5 pr-8 text-sm text-brand-ink focus:border-brand-ink focus:ring-brand-ink"
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value as "recent" | "highest" | "lowest")}
      >
        <option value="recent">Most recent</option>
        <option value="highest">Highest rated</option>
        <option value="lowest">Lowest rated</option>
      </select>
    </div>
  );
};

export default ReviewFilters;
